import Vue from 'vue';
import Vuex from 'vuex';

import config from './modules/config.store';
import streamcast from './modules/streamcast.store';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    config,
    streamcast,
  },
});
